import {globalImport} from "@/shared-services";

setTimeout(() => {
  globalImport.importNow('CommandZendesk').subscribe(() => {
    window.zESettings = {
      webWidget: {
        position: { horizontal: 'right'},
        offset: {
          horizontal: '-10px',
          vertical: '100px'
        },
        contactForm: {
          attachments: false
        },
        chat: {
          departments: {
            select: "Command",
            enabled: ["Command"]
          }
        }
      }
    }
    window.zE('webWidget', 'setLocale', 'en-US');
    window.zE('webWidget', 'hide')
// if (!zendeskWhitelist.some(item => item.test(location.pathname))) {
//   zE('webWidget', 'hide');
// }
    window.zE('webWidget:on', 'close', function() {
      window.zE('webWidget', 'hide')
    })
  })
})
